import { render, staticRenderFns } from "./costhis.vue?vue&type=template&id=0838279a&scoped=true&"
import script from "./costhis.vue?vue&type=script&lang=js&"
export * from "./costhis.vue?vue&type=script&lang=js&"
import style0 from "./costhis.vue?vue&type=style&index=0&id=0838279a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838279a",
  null
  
)

export default component.exports